import * as yup from "yup";

const personalInformationSchema = yup.object().shape({
  prefix_name: yup
    .string()
    .trim()
    .matches(/^[A-Za-z.]+$/, "Prefix name is not valid")
    .min(2, "Prefix name must be atleast 2 characters")
    .max(255, "Prefix name should be less than 255 characters"),
  first_name: yup
    .string()
    .trim()
    .matches(
      /^([a-zA-Z]+\s)*[a-zA-Z]+$/,
      "Numbers, special characters not allowed in first name"
    )
    .min(1, "First name must be atleast 1 character")
    .max(255, "First name should be less than 255 characters")
    .required("First name is required"),
  middle_name: yup
    .string()
    .trim()
    .matches(
      /^([a-zA-Z]+\s)*[a-zA-Z]+$/,
      "Numbers, special characters not allowed in middle Name"
    )
    .max(255, "Middle name should be less than 255 characters"),
  last_name: yup
    .string()
    .trim()
    .matches(
      /^([a-zA-Z]+\s)*[a-zA-Z]+$/,
      "Numbers, special characters not allowed in last name"
    )
    .max(255, "Last name should be less than 255 characters"),
  degree: yup
    .string()
    .trim() // .matches(/^[A-Za-z.]+$/, 'Please enter valid format!!')
    .min(2, "Degree must be atleast 2 characters")
    .required("Degree is required"),
  phone_no: yup
    .string()
    .trim()
    .max(13, "Phone number must be exactly 10 digits")
    .required("Phone number is required")
    .matches(
      /^(\+91[\-\s]?)?(\+72[\-\s]?)?(\+52[\-\s]?)?(\+81[\-\s]?)?(\+92[\-\s]?)?[6789]\d{9}$/,
      "Enter a valid phone number"
    ),
  email: yup
    .string()
    .trim()
    .matches(/^[a-zA-Z0-9@._]*$/, "Email Id is invalid")
    .email("Please provide a valid email id")
    .min(2, "Email id must be atleast 2 characters")
    .max(100, "Email id should be less than 100 characters")
    .required("Email id is required"),
  address: yup
    .string()
    .trim() // .matches(/^[A-Za-z0-9,.'"& ]+$/, 'Must not contain any special character!!')
    .min(2, "Address must be atleast 2 characters")
    .max(300, "Address should be less than 300 characters")
    .required("Address is required"),
  zipcode: yup
    .string()
    .trim()
    .matches(
      /^[0-9]*$/,
      "any special/normal characters, spaces not allowed in Pincode"
    )
    .min(5, "Pincode must be atleast 5 digits")
    .max(6, "Pincode must be not more than 6 digits")
    .required("Pincode is required"),
  // fees: yup
  //   .string()
  //   .matches(/^[0-9.]*$/, "Fees is required and must be valid")
  //   .required("Fees is required and must be valid")
  //   .test("len", "Fees must be less than 10 lakhs", (val) => val <= 1000000),
  years_of_experience: yup
    .string()
    .test("len", "Experience is required", (val) => val != 0)
    .matches(
      /^([0-6]\d|[0-9])(\.[0-9]{1,2})?$/,
      "Enter valid years of experience"
    )
    .required("Years of Experience is required"),
  // doctor_specialization_id: yup.string().required('Specialization required'),
  // about: yup
  //   .string()
  //   .trim()
  //   .min(2, "About must be atleast 2 characters")
  //   .max(300, "About should be less than 300 characters"),
  // description: yup
  //   .string()
  //   .trim()
  //   .min(2, "Description must be atleast 2 characters")
  //   .max(1000, "Description should be less than 300 characters"),
  // state_code: yup.string().test("state", "State is required", (value) => {
  //   return value > 0;
  // }),
  // doctor_specialization_id: yup.string().required("Specialization is required"),
});

export default personalInformationSchema;
